/**
 * This file is part of vue-boilerplate.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 TINYMINS.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { finalizeAction, ActionType } from '@/store/actions';
import { UserBasic } from '@/api/types/user';

export interface StoreUserOnlineState {
  game: string;
  gender: number;
  users: UserBasic[];
  loading: boolean;
  point: number;
  noMore: boolean;
}

export default {
  namespaced: true,
  modules: {},
  state: {
    game: null,
    gender: null,
    users: [],
    loading: false,
    point: null,
    noMore: false,
  },
  getters: {},
  actions: {
    [USER.GET_ONLINE_USER](
      { commit, state },
      { game, gender, action: rawAction = '' }: { game?: string; gender?: number; action?: ActionType } = {},
    ) {
      const action = finalizeAction(rawAction, state.game === game && state.gender === gender, state.noMore);
      if (action) {
        const point = action === 'more' ? state.point : null;
        commit(USER.GET_ONLINE_USER, { status: 'start' });
        return new Promise((resolve, reject) => {
          api.getOnlineUser(game, gender, state.limit, point).then((res) => {
            commit(USER.GET_ONLINE_USER, {
              status: 'success',
              game,
              gender,
              action,
              data: res.data,
              point: res.extra.nextPoint,
            });
            resolve();
          }).catch((err) => {
            commit(USER.GET_ONLINE_USER, { status: 'failure' });
            reject(err);
          });
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [USER.GET_ONLINE_USER](state, { status, game, gender, action, data, point }) {
      if (status === 'start') {
        state.loading = true;
      } else {
        if (status === 'success') {
          state.game = game;
          state.gender = gender;
          state.point = point;
          state.noMore = point === 0;
          state.users = action === 'reload' ? data : state.users.concat(data);
        }
        state.loading = false;
      }
    },
  },
};
